import { Dispatch } from "redux";
import { createActionCreator, createReducer } from "deox";
import * as optsService from "../services/filterOptions";
import { FilterOption } from "../models/misc";

export type State = {
  byFilter: Record<number, FilterOption[]>; 
  data:     FilterOption | null;
};

const defaultState: State = {
  byFilter: {},
  data:     null
};

// fetch for one filter
const fetchOptions = Object.assign(
  (filterId: number) => async (dispatch: Dispatch) => {
    try {
      const result = await optsService.getFilterOptions(filterId);
      dispatch(fetchOptions.success({ filterId, options: result }));
    } catch {}
  },
  {
    success: createActionCreator(
      "@@FILTEROPTIONS/FETCH",
      resolve => (payload: { filterId: number; options: FilterOption[] }) => resolve(payload)
    )
  }
);

const createOption = (option: Partial<FilterOption>) => async (dispatch: any) => {
  try {
    await optsService.createOption(option);
    dispatch(fetchOptions(option.filterId!));
  } catch {}
};

const updateOption = (option: FilterOption) => async (dispatch: any) => {
  try {
    await optsService.updateOption(option);
    dispatch(fetchOptions(option.filterId));
  } catch {}
};

const deleteOption = (filterId: number, optionId: number) => async (dispatch: any) => {
  try {
    await optsService.deleteOption(filterId, optionId);
    dispatch(fetchOptions(filterId));
  } catch {}
};

const reducer = createReducer(defaultState, handleAction => [
  handleAction(fetchOptions.success, (state, action) => ({
    ...state,
    byFilter: {
      ...state.byFilter,
      [action.payload.filterId]: action.payload.options
    }
  }))
]);

const actions = {
  fetchOptions,
  createOption,
  updateOption,
  deleteOption
};

export { actions, reducer };
